import React, { useState, useRef, useEffect } from "react";
import { IoSwapVertical, IoChevronDown, IoCheckmark } from "react-icons/io5";

const SORT_OPTIONS = [
  { value: "latest_updated", label: "Latest Updated" },
  { value: "latest_scheduled", label: "Latest Scheduled" },
  { value: "alphabetical", label: "Alphabetical (A–Z)" },
  { value: "priority", label: "Priority (Urgent - Low)" },
];

export default function SortDropdown({ value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedOption =
    SORT_OPTIONS.find((opt) => opt.value === value) || SORT_OPTIONS[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none dark:border-white/10 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
      >
        <IoSwapVertical className="h-4 w-4 text-brand-500 dark:text-brand-400" />
        <span className="whitespace-nowrap">
          Sort: <strong className="font-semibold text-navy-700 dark:text-white">{selectedOption.label}</strong>
        </span>
        <IoChevronDown className={`h-4 w-4 text-gray-500 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 z-30 mt-2 w-52 origin-top-right rounded-xl border border-gray-200 bg-white p-1.5 shadow-xl dark:border-navy-700 dark:bg-navy-800">
          <div className="px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-400">
            Sort Options
          </div>
          {SORT_OPTIONS.map((option) => {
            const isSelected = option.value === selectedOption.value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  onChange(option.value);
                  setIsOpen(false);
                }}
                className={`flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left text-sm font-medium transition-colors ${
                  isSelected
                    ? "bg-brand-50 text-brand-600 dark:bg-brand-500/10 dark:text-brand-400 font-semibold"
                    : "text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-white/5"
                }`}
              >
                <span>{option.label}</span>
                {isSelected && <IoCheckmark className="h-4 w-4 text-brand-500" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
